import { createFileRoute } from '@tanstack/react-router'
import TeacherTimetable from '@/components/teacherPage/Timetable'

export const Route = createFileRoute('/teacher/timetable')({
  component: TeacherTimetable,
})

export default TeacherTimetable
